const e = {
  none: "none",
  small: "0 0.25rem 1rem rgba(104, 104, 104, 0.08)",
  medium: "0 0.5rem 1rem rgba(104, 104, 104, 0.08)"
};
export {
  e as default
};
